import { type CoreBrand, type CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveBrand = (state: CoreState): CoreBrand | undefined => {
  return findActiveBrand(state)
}
